import _createClass from "/Users/jonathan/programming/rvx-lc/www/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/jonathan/programming/rvx-lc/www/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/jonathan/programming/rvx-lc/www/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/jonathan/programming/rvx-lc/www/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/Users/jonathan/programming/rvx-lc/www/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/Users/jonathan/programming/rvx-lc/www/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/jonathan/programming/rvx-lc/www/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "/Users/jonathan/programming/rvx-lc/www/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import { decodePacket } from "engine.io-parser";
import { Emitter } from "@socket.io/component-emitter";
import { installTimerFunctions } from "./util.js";
import { encode } from "./contrib/parseqs.js";
export var TransportError = /*#__PURE__*/function (_Error) {
  _inherits(TransportError, _Error);

  var _super = _createSuper(TransportError);

  function TransportError(reason, description, context) {
    var _this;

    _classCallCheck(this, TransportError);

    _this = _super.call(this, reason);
    _this.description = description;
    _this.context = context;
    _this.type = "TransportError";
    return _this;
  }

  return TransportError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var Transport = /*#__PURE__*/function (_Emitter) {
  _inherits(Transport, _Emitter);

  var _super2 = _createSuper(Transport);

  /**
   * Transport abstract constructor.
   *
   * @param {Object} opts - options
   * @protected
   */
  function Transport(opts) {
    var _this2;

    _classCallCheck(this, Transport);

    _this2 = _super2.call(this);
    _this2.writable = false;
    installTimerFunctions(_assertThisInitialized(_this2), opts);
    _this2.opts = opts;
    _this2.query = opts.query;
    _this2.socket = opts.socket;
    return _this2;
  }
  /**
   * Emits an error.
   *
   * @param {String} reason
   * @param description
   * @param context - the error context
   * @return {Transport} for chaining
   * @protected
   */


  _createClass(Transport, [{
    key: "onError",
    value: function onError(reason, description, context) {
      _get(_getPrototypeOf(Transport.prototype), "emitReserved", this).call(this, "error", new TransportError(reason, description, context));

      return this;
    }
    /**
     * Opens the transport.
     */

  }, {
    key: "open",
    value: function open() {
      this.readyState = "opening";
      this.doOpen();
      return this;
    }
    /**
     * Closes the transport.
     */

  }, {
    key: "close",
    value: function close() {
      if (this.readyState === "opening" || this.readyState === "open") {
        this.doClose();
        this.onClose();
      }

      return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */

  }, {
    key: "send",
    value: function send(packets) {
      if (this.readyState === "open") {
        this.write(packets);
      } else {// this might happen if the transport was silently closed in the beforeunload event handler
      }
    }
    /**
     * Called upon open
     *
     * @protected
     */

  }, {
    key: "onOpen",
    value: function onOpen() {
      this.readyState = "open";
      this.writable = true;

      _get(_getPrototypeOf(Transport.prototype), "emitReserved", this).call(this, "open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */

  }, {
    key: "onData",
    value: function onData(data) {
      var packet = decodePacket(data, this.socket.binaryType);
      this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */

  }, {
    key: "onPacket",
    value: function onPacket(packet) {
      _get(_getPrototypeOf(Transport.prototype), "emitReserved", this).call(this, "packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */

  }, {
    key: "onClose",
    value: function onClose(details) {
      this.readyState = "closed";

      _get(_getPrototypeOf(Transport.prototype), "emitReserved", this).call(this, "close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */

  }, {
    key: "pause",
    value: function pause(onPause) {}
  }, {
    key: "createUri",
    value: function createUri(schema) {
      var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
  }, {
    key: "_hostname",
    value: function _hostname() {
      var hostname = this.opts.hostname;
      return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
  }, {
    key: "_port",
    value: function _port() {
      if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) {
        return ":" + this.opts.port;
      } else {
        return "";
      }
    }
  }, {
    key: "_query",
    value: function _query(query) {
      var encodedQuery = encode(query);
      return encodedQuery.length ? "?" + encodedQuery : "";
    }
  }]);

  return Transport;
}(Emitter);